// extracted by mini-css-extract-plugin
module.exports = {"selectedTypesList":"_2nmDcJkbOIN358ukQ4wQiD"};